import React, { useMemo } from 'react';

const SYMBOLS = ['€', '€', '€', '€', '💶', '💰', '💵'];

const MoneyRain = ({ count = 40 }) => {
  const drops = useMemo(() => {
    return Array.from({ length: count }).map((_, i) => ({
      id: i,
      symbol: SYMBOLS[Math.floor(Math.random() * SYMBOLS.length)],
      left: Math.random() * 100,
      size: 24 + Math.random() * 48,
      duration: 5 + Math.random() * 7,
      delay: Math.random() * 8,
      rotation: (Math.random() - 0.5) * 720,
      swing: (Math.random() - 0.5) * 120,
      isEmoji: false,
    }));
  }, [count]);

  return (
    <div className="money-rain-container" aria-hidden="true" data-testid="money-rain">
      {drops.map((d) => {
        const isEmoji = d.symbol !== '€';
        return (
          <span
            key={d.id}
            className={isEmoji ? 'money-drop money-drop-emoji' : 'money-drop money-drop-euro'}
            style={{
              left: `${d.left}%`,
              fontSize: `${d.size}px`,
              animationDuration: `${d.duration}s`,
              animationDelay: `${d.delay}s`,
              '--rotate-end': `${d.rotation}deg`,
              '--swing': `${d.swing}px`,
            }}
          >
            {d.symbol}
          </span>
        );
      })}
    </div>
  );
};

export default MoneyRain;
